import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "antd";
import { LinkOutlined } from "@ant-design/icons";

const PatentCenterLink = ({ value }) => {
  const url = `https://patentcenter.uspto.gov/applications/${value}`;
  const styleIcon = {
    marginLeft: 4
  };
  return (
    <Tooltip title="View USPTO Patent Center">
      <a href={url} target="_blank" rel="noopener noreferrer nofollow" style={styleIcon}>
        <LinkOutlined />
      </a>
    </Tooltip>
  );
};

PatentCenterLink.propTypes = {
  value: PropTypes.string.isRequired
};

export default PatentCenterLink;
